export default __webpack_public_path__ + "static/media/320x180.119819aa.jpg";